import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './composants/login/login.component';
import { SignupComponent } from './composants/signup/signup.component';
import { ProfilComponent } from './composants/profil/profil.component';
import { ModifyUserComponent } from './composants/modify-user/modify-user.component';
import { ViewUserComponent } from './composants/view-user/view-user.component';
import { VerifyEmailComponent } from './composants/verify-email/verify-email.component';
import { ForgotPasswordComponent } from './composants/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './composants/reset-password/reset-password.component';
import { CompleteProfilComponent } from './composants/complete-profil/complete-profil.component';
import { AuthRoutingModule } from './auth-routing.module';
import { SharedModule } from '../../shared/shared.module';


@NgModule({
  declarations: [
     
    LoginComponent,
    SignupComponent,
    ProfilComponent,
    ModifyUserComponent,
    ViewUserComponent,
    VerifyEmailComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    CompleteProfilComponent,

  ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    SharedModule
  ]
})
export class AuthModule { }
